/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */

import * as beet from '@metaplex-foundation/beet'
import * as web3 from '@solana/web3.js'
import { InitPayload, initPayloadBeet } from '../types/InitPayload'

/**
 * @category Instructions
 * @category InitListing
 * @category generated
 */
export type InitListingInstructionArgs = {
  payload: InitPayload
}
/**
 * @category Instructions
 * @category InitListing
 * @category generated
 */
export const initListingStruct = new beet.FixableBeetArgsStruct<
  InitListingInstructionArgs & {
    instructionDiscriminator: number[] /* size: 8 */
  }
>(
  [
    ['instructionDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['payload', initPayloadBeet],
  ],
  'InitListingInstructionArgs'
)
/**
 * Accounts required by the _initListing_ instruction
 *
 * @property [_writable_] listing
 * @property [_writable_, **signer**] publisher
 * @property [_writable_] protocolTreasury
 * @property [] solUsdFeed
 * @property [_writable_] application
 * @category Instructions
 * @category InitListing
 * @category generated
 */
export type InitListingInstructionAccounts = {
  listing: web3.PublicKey
  publisher: web3.PublicKey
  protocolTreasury: web3.PublicKey
  solUsdFeed: web3.PublicKey
  application: web3.PublicKey
  systemProgram?: web3.PublicKey
  anchorRemainingAccounts?: web3.AccountMeta[]
}

export const initListingInstructionDiscriminator = [
  163, 104, 120, 177, 101, 20, 250, 169,
]

/**
 * Creates a _InitListing_ instruction.
 *
 * @param accounts that will be accessed while the instruction is processed
 * @param args to provide as instruction data to the program
 *
 * @category Instructions
 * @category InitListing
 * @category generated
 */
export function createInitListingInstruction(
  accounts: InitListingInstructionAccounts,
  args: InitListingInstructionArgs,
  programId = new web3.PublicKey('ListaMe2rbrc8w5X2gnzQvZzPBGLNCB6VuVAKCgRHU4')
) {
  const [data] = initListingStruct.serialize({
    instructionDiscriminator: initListingInstructionDiscriminator,
    ...args,
  })
  const keys: web3.AccountMeta[] = [
    {
      pubkey: accounts.listing,
      isWritable: true,
      isSigner: false,
    },
    {
      pubkey: accounts.publisher,
      isWritable: true,
      isSigner: true,
    },
    {
      pubkey: accounts.protocolTreasury,
      isWritable: true,
      isSigner: false,
    },
    {
      pubkey: accounts.solUsdFeed,
      isWritable: false,
      isSigner: false,
    },
    {
      pubkey: accounts.application,
      isWritable: true,
      isSigner: false,
    },
    {
      pubkey: accounts.systemProgram ?? web3.SystemProgram.programId,
      isWritable: false,
      isSigner: false,
    },
  ]

  if (accounts.anchorRemainingAccounts != null) {
    for (const acc of accounts.anchorRemainingAccounts) {
      keys.push(acc)
    }
  }

  const ix = new web3.TransactionInstruction({
    programId,
    keys,
    data,
  })
  return ix
}
